var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h3',[_vm._v("Mailing of promotional codes")]),_vm._v(" "),_c('p',[_vm._v("The "+_vm._s(_vm.host)+" team thanks you for your trust. As a sign of appreciation we will periodically send promotional codes to regular customers. Have a nice game!")])])}
var staticRenderFns = []

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// c:/Jenkins/workspace/play-at-home-test-frontend-deploy-sites/src/onlinecasino/OnlineCasino.Web.Public/node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!c:/Jenkins/workspace/play-at-home-test-frontend-deploy-sites/src/onlinecasino/OnlineCasino.Web.Public/node_modules/vue-loader/lib??vue-loader-options!./skins/bulmasite/components/pages/sitepages/bonus-rules/bonus-rules-mailing/en.vue?vue&type=template&id=d557c3da
// module id = EMzp
// module chunks = 0